// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_SMART_BANNER_LABELS = 'global.smartBanner';

export const lblSmartBannerButton = `lbl_smart_banner_button`;
export const lblSmartBannerDescGym = `lbl_smart_banner_desc_gym`;
export const lblSmartBannerDescPjp = `lbl_smart_banner_desc_pjp`;
export const lblSmartBannerDescSnj = `lbl_smart_banner_desc_snj`;
export const lblSmartBannerDescTcp = `lbl_smart_banner_desc_tcp`;
export const lblSmartBannerTitlePjp = `lbl_smart_banner_title_pjp`;
export const lblSmartBannerTitleTcp = `lbl_smart_banner_title_tcp`;

export const AppBannerLabels = {
  global: {
    smartBanner: {
      [lblSmartBannerButton]: 'Open',
      [lblSmartBannerDescGym]: 'Open in Gymboree app',
      [lblSmartBannerDescPjp]: 'Open in The PJPlace app',
      [lblSmartBannerDescSnj]: 'Open in Sugar & Jade app',
      [lblSmartBannerDescTcp]: "Open in The Children's Place app",
      [lblSmartBannerTitlePjp]: 'PJPlace',
      [lblSmartBannerTitleTcp]: "The Children's Place",
    },
  },
};
